import {
  CREATE_EDIT_LPS_CONFIG_REQUEST,
  DELETE_LPS_CONFIG_REQUEST,
  RECEIVE_LPS_CONFIGS_REQUEST,
  RUN_PROCESSING_LPS_REQUEST,
  CHECK_LPS_USAGE_REQUEST,
  RESET_CURRENT_CALCULATION_REQUEST,
} from "../../../common/constants/action-constants";
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest, delay } from "redux-saga/effects";
import {
  createEditLPSConfigsError,
  createEditLPSConfigsSuccess,
  deleteLPSConfigError,
  deleteLPSConfigSuccess,
  receiveLPSConfigsError,
  receiveLPSConfigsSuccess,
  finishCountLPSDataSuccess,
  finishCountLPSDataError,
  checkLpsUsageRequest,
  checkLpsUsageSuccess,
  checkLpsUsageError,
  resetCurrentCalculationSuccess,
  receiveLPSConfigsRequest,
} from '../actions';
import type { StartCountLPSDataRequestAction } from '../actions';
import ApiService from "../../../common/services/api.service";
import AlertService from "../../../common/services/notification.service";
import UserService from "../../../common/services/user.service";
import { notificationMessage } from '../../../common/constants/notication-constants';
import { mapToApiError } from '../../../common/services/api-error';

function* createEditLPSConfig(action) {
  try {
    const result = yield call(ApiService.post, "/lps/configs", action.data);
    if (result && result.data.message) {
      yield put(createEditLPSConfigsSuccess(result.data.message));
      yield put(receiveLPSConfigsRequest());
    } else {
      AlertService.error("SOMETHING WENT WRONG");
    }
  } catch (error) {
    yield put(createEditLPSConfigsError(error));
  }
}

function* getLPSConfigs() {
  try {
    if (!UserService.token) return;
    const lpsConfigs = yield call(ApiService.get, "/lps/configs");
    yield put(receiveLPSConfigsSuccess(lpsConfigs.data));
  } catch (error) {
    yield put(receiveLPSConfigsError(error));
  }
}

function* deleteLPSConfigs(action) {
  try {
    const result = yield call(ApiService.delete, `/lps/configs/${action.id}`);
    const message: string = result.data?.message ?? 'LPS config successfully removed!';
    yield put(deleteLPSConfigSuccess({ type: "success", message }));
    yield call(AlertService.success, message);
    yield put(receiveLPSConfigsRequest());
  } catch (error) {
    const apiError = mapToApiError(error);

    if (apiError.status === 404) {
      yield put(deleteLPSConfigSuccess({ type: "info", message: apiError.message ?? notificationMessage.LPS_CONFIG_DELETE_NOT_FOUND }));
      yield call(AlertService.info, apiError.message ?? notificationMessage.LPS_CONFIG_DELETE_NOT_FOUND)
      yield put(receiveLPSConfigsRequest());
      return;
    }
    yield put(deleteLPSConfigError(apiError));
    yield call(AlertService.error, `SOMETHING WENT WRONG. Error: ${apiError.message ?? "Uninstall error"}`)
  }
}

function* receiveLPSResult(action: StartCountLPSDataRequestAction) {
  try {
    UserService.setLPCIdent = action.query.ident;
    const result = yield call(ApiService.post, "/lps/rating", action.query);
    if (result.data.success) {
      AlertService.info(result.data.message);
      yield put(checkLpsUsageRequest());
    } else {
      AlertService.error(result.data.message);
    }
  } catch (error) {
    yield put(finishCountLPSDataError(error));
  }
}

function* checkLpsUsage(action: ReturnType<typeof checkLpsUsageRequest>): SagaIterator {
  try {
    // let result: any;
    while (true) {
      const ident = UserService.LPCIdent;
      const result = yield call(ApiService.post, "/lps/check_lps", {
        ident
      });
      if (action.needAlertFlag) {
        AlertService.info(result.data.message);
      }
      if (result.data.canUse) {
        if ( Array.isArray(result.data.lpc?.lpc) && result.data.lpc?.lpc.length > 0 ) {
          AlertService.success(result.data.message);
          UserService.delLPCIdent();
          UserService.setLPC = JSON.stringify(result.data.lpc);
          yield put(finishCountLPSDataSuccess(result.data.lpc));
        } else {
          UserService.delLPCIdent();
        }
        yield put(checkLpsUsageSuccess(result.data.message));
        break;
      } else {
        if (result.data.timeout) {
          yield delay(result.data.timeout);
          continue;
          // yield put(checkLpsUsageRequest());
        }
      }
      yield put(checkLpsUsageSuccess(result.data.message));
      break;
    }
  } catch (error) {
    yield put(checkLpsUsageError(error));
  }
}

function* resetCurrentCalculation(action) {
  try {
    const result = yield call(ApiService.post, "/lps/reset_calculation", {
      ident: action.ident,
    });
    if (result) {
      AlertService.info(result.data.message);
      yield put(resetCurrentCalculationSuccess(result.data));
    }
  } catch (error) {
    console.log("Error: ", error);
  }
}

export default function* actionLPS() {
  yield takeLatest(CREATE_EDIT_LPS_CONFIG_REQUEST, createEditLPSConfig);
  yield takeLatest(RECEIVE_LPS_CONFIGS_REQUEST, getLPSConfigs);
  yield takeLatest(DELETE_LPS_CONFIG_REQUEST, deleteLPSConfigs);
  yield takeLatest(RUN_PROCESSING_LPS_REQUEST, receiveLPSResult);
  yield takeLatest(CHECK_LPS_USAGE_REQUEST, checkLpsUsage);
  yield takeLatest(RESET_CURRENT_CALCULATION_REQUEST, resetCurrentCalculation);
}
